import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { DashboardLayout } from '@/components/layouts/DashboardLayout'
import { LoadingSpinner } from '@/components/features/LoadingSpinner'
import { LineBasedInvoicePageContent } from '@/components/features/invoicing/LineBasedInvoicePageContent'
import { getProjectById, getProjectInvoices } from '@/lib/api/projects'

export default function StandaloneInvoicePage() {
  const { id: projectId } = useParams<{ id: string }>()

  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [remainingAmount, setRemainingAmount] = useState(0)
  const [defaultVatPercent, setDefaultVatPercent] = useState<number | undefined>(undefined)

  useEffect(() => {
    if (!projectId) return
    const load = async () => {
      try {
        // Invoices + project in parallel — project.vatRate feeds the
        // line editor so new lines default to the project VAT instead of
        // the previously-hardcoded 21 %. QA-BUG-04.
        const [data, project] = await Promise.all([
          getProjectInvoices(projectId),
          getProjectById(projectId),
        ])
        setRemainingAmount(data.project.totalRemaining)
        if (project?.vatRate != null) {
          setDefaultVatPercent(Math.round(project.vatRate * 100))
        }
      } catch {
        setError('Erreur lors du chargement des données de facturation')
      } finally {
        setIsLoading(false)
      }
    }
    void load()
  }, [projectId])

  if (isLoading) {
    return (
      <DashboardLayout>
        <div className="flex justify-center py-16">
          <LoadingSpinner />
        </div>
      </DashboardLayout>
    )
  }

  return (
    <DashboardLayout>
      <LineBasedInvoicePageContent
        projectId={projectId ?? ''}
        title="Facture supplémentaire"
        description="Saisie libre des lignes à facturer"
        remainingAmount={remainingAmount}
        initialLines={[]}
        invoiceType="standalone"
        error={error}
        defaultVatPercent={defaultVatPercent}
      />
    </DashboardLayout>
  )
}
